import styled from "styled-components";

export const SwitchButton = ({ setShowSeguimiento, readOnly }) => {
  
  return (
    <Container>
      <label className="switch" >
        <input readOnly={readOnly} type="checkbox" onClick={() => {
          setShowSeguimiento(prev => !prev)
          }}/>
        <span className="slider round"></span>
      </label>
    </Container>
  );
};

const Container = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 32px;
    height: 16px;
    margin: auto 0;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: var(--primary-pistachio);
  }

  input:focus + .slider {
    box-shadow: 0 0 1px var(--primary-pistachio);
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(16px);
    -ms-transform: translateX(16px);
    transform: translateX(16px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
`;
